import React from 'react';
import { base } from '../../helper/base-helper';
import { Form, Progress } from 'semantic-ui-react';

class UploadFile extends React.Component {

  // component takes a resetEval to evaluate prop change that resets the percentage.

  constructor(props) {
    super(props);
    this.state = {
      percentage: 0,
      error: false,
      success: false,
      loading: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetEval !== this.props.resetEval) {
      this.setState({percentage: 0, success: false, error: false})
    }
  }

  handleFileSelect = (e) => {
    e.persist();
    const setState = (obj) => this.setState(obj);
    const { fieldName, getUploadData, location='actionscreenshots/' } = this.props;

    // handle when user clicks cancel in upload file dialogue
    if(!e.target.value)
    return setState({percentage:0, success: false, error: true});

    // get file
    const file = e.target.files[0];

    // create storage ref
    const storageRef = base.storage().ref(location + file.name)

    // upload file
    const task = storageRef.put(file);

    // update state
    task.on('state_changed',
      function progress(snap) {
        const percentage = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
        setState({percentage, loading: true});
      },

      function error(err) {
        setState({error: true, loading: false})
        console.error(err);
      },

      function complete() {
        storageRef.getMetadata().then(data => {
          getUploadData(e, {value: data.downloadURLs[0], name: fieldName});
        });
        setState({success: true, loading: false});
      }
    );
  };

  render() {
    return (
      <div>
        <Form.Input
          disabled={this.props.disabled}
          name='uploadFile'
          label='Upload Screenshot (will generate URL below)'
          type='file'
          icon='upload'
          error={this.state.error}
          loading={this.state.loading}
          onChange={this.handleFileSelect}
        />
        { (this.props.showProgressBar)
          ? <Progress progress autoSuccess
            width={8}
            percent={this.state.percentage}
            error={this.state.error}
            success={this.state.success}
            />
          : '' }
      </div>
    );
  }

}

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/forms/UploadFile.js